import { callTenantGetApi, callTenantPostApi } from "../interceptor";

// Add Tenant API function
export async function registerTenant(data) {
    try {
      const response = await callTenantPostApi({ url: "users/account/register", body: data });
      return response;
    } catch (error) {
      throw error;
    }
  }

  export async function selectPlanApi(id, data) {
    try {
      const response = await callTenantPostApi({ url: `users/account/subscribe-plan/${id}`, body: data });
      return response;
    } catch (error) {
      throw error;
    }
    return response;
  }

  export async function getUserPlans(data) {
    try {
      const response = await callTenantGetApi({ url: "plans", body: data });
      return response;
    } catch (error) {
      throw error;
    }
  }
  export async function getUserCoupons(data) {
    try {
      const response = await callTenantGetApi({ url: "coupons", body: data });
      return response;
    } catch (error) {
      throw error;
    }
  }

export async function couponValidate(data) {
  try {
    const response = await callTenantPostApi({ url: "users/account/coupon-validity", body: data });
    return response;
  } catch (error) {
    throw error;
  }
}